import type { OrderTableHeader } from '../components/Tables/OrderTableWithDetails.component';

export const ORDER_TABLE_HEADERS: OrderTableHeader[] = [
  { key: 'owner', label: 'Client', minWidth: 250, align: 'left' },
  { key: 'status', label: 'Statut', minWidth: 150, align: 'left' },
  { key: 'advStatus', label: 'ADV', minWidth: 150, align: 'left' },
  { key: 'totalHt', label: 'Total HT', minWidth: 100, align: 'right' },
  { key: 'totalTtc', label: 'Total TTC', minWidth: 100, align: 'right' },
  { key: 'deliveryDay', label: 'Livraison le', minWidth: 100, align: 'left' },
  { key: 'created', label: 'Création le', minWidth: 150, align: 'right' },
];
